<template>
  <div class="all-comment-box">
    <van-tabs v-model="active">
      <van-tab :title="'全部('+allCount+')'">
        <van-pull-refresh v-if=" commentList.length != 0" v-model="isLoading" @refresh="onRefresh" success-text="刷新成功">
          <van-list v-model="loading" :immediate-check="false" :finished="finished" finished-text="没有更多了" @load="onLoad" :offset="1">
            <div class="item-box">
              <div class="line"></div>
              <van-row class="list" v-if="commentList.length != 0">
                <div class="comment-item" v-for="(item,index) in commentList" :key="index">
                  <div class="comment-item-top">
                    <div class="comment-item-name">

                      <img :src="item.userInfo.avatarUrl" alt="">

                      <div class="item-name">{{item.userInfo.nickName}}</div>

                    </div>
                    <div class="comment-item-tiem">{{item.addTime}}</div>
                  </div>
                  <div class="comment-item-content">{{item.content}}</div>
                  <div class="comment-img">
                    <van-grid :column-num="4" :gutter="5">
                      <van-grid-item v-for="(img,idx) in item.picList" :key="idx" :icon="img" text="" @click="showImgs(item.picList,idx)" />
                    </van-grid>
                    <!-- <div class="comment-img-box" v-for="(img,idx) in item.picList" :key="idx">
                      <img :src="img" alt="" srcset="">

                    </div> -->

                  </div>
                </div>
              </van-row>
              <div v-else>
                <img width="100%" src="../../assets/index/no_data.png" alt="">
                <div class="no-data">暂无数据</div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <van-tab :title="'有图片('+hasPicCount+')'">
        <div class="item-box">
          <div class="line"></div>
          <van-row class="list" v-if="commentListHasPic.length != 0">
            <div class="comment-item" v-for="(item,index) in commentListHasPic" :key="index">
              <div class="comment-item-top">
                <div class="comment-item-name">
                  <img :src="item.userInfo.avatarUrl" alt="">
                  <div class="item-name">{{item.userInfo.nickName}}</div>

                </div>
                <div class="comment-item-tiem">{{item.addTime}}</div>
              </div>
              <div class="comment-item-content">{{item.content}}</div>
              <div class="comment-img">
                <van-grid :column-num="4" :gutter="5">
                  <van-grid-item v-for="(img,idx) in item.picList" :key="idx" @click="showImgs(item.picList,idx)" :icon="img" text="" />
                </van-grid>
                <!-- <van-grid :column-num="2" :gutter="5">
                  <div class="comment-img-box" v-for="(img,idx) in item.picList" :key="idx">
                    <img :src="img" alt="" srcset="">

                  </div>

                </van-grid> -->

              </div>
            </div>
          </van-row>
          <div v-else>
            <img width="100%" src="../../assets/index/no_data.png" alt="">
            <div class="no-data">暂无数据</div>
          </div>
        </div>
      </van-tab>
    </van-tabs>

  </div>

</template>

<script>
import { commentList } from "@/api/index";
import { Toast, Dialog, ImagePreview } from "vant";

export default {
  name: "allComent",
  components: {
    ImagePreview
  },
  data() {
    return {
      active: 0,
      hasPicCount: 0,
      allCount: 0,
      dataInfo: {
        valueId: "",
        showType: 0,
        type: 0,
        page: 1,
        size: 10
      },
      dataInfoHaspic: {
        valueId: "",
        showType: 1,
        type: 0,
        page: 1,
        size: 10
      },
      commentList: [],
      commentListHasPic: [],
      isLoading: true,
      loading: false,
      finished: false
    };
  },
  created() {
    console.log(this.$route.query.comment);
    this.dataInfo.valueId = this.$route.query.comment;
    this.dataInfoHaspic.valueId = this.$route.query.comment;

    console.log(this.dataInfo);
    this.getList(this.dataInfo);
    this.getListHasPic(this.dataInfoHaspic);
  },
  methods: {
    showImgs(list, idx) {
      ImagePreview({
        images: list,
        startPosition: idx,
        onClose() {
          // do something
        }
      });
    },
    getList(data) {
      commentList(data).then(res => {
        console.log(res);
        if (res.data.errno == 0) {
          this.commentList = this.commentList.concat(res.data.data.data);
          this.loading = false;
          this.allCount = res.data.data.count;
          // // 数据全部加载完成
          if (this.commentList.length == res.data.data.count) {
            this.finished = true;
          }
          console.log(this.commentList);
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg
          });
        }
      });
    },
    getListHasPic(data) {
      commentList(data).then(res => {
        console.log(res);
        if (res.data.errno == 0) {
          this.commentListHasPic = this.commentListHasPic.concat(
            res.data.data.data
          );
          this.loading = false;
          this.hasPicCount = res.data.data.count;
          // // 数据全部加载完成
          if (this.commentListHasPic.length == res.data.data.count) {
            this.finished = true;
          }
          console.log(this.commentListHasPic);
        } else {
          Dialog.alert({
            title: "提示",
            message: res.data.errmsg
          });
        }
      });
    },
    onRefresh() {
      setTimeout(() => {
        Toast("刷新成功");
        this.isLoading = false;

        this.dataInfo.page = 1;
        this.commentList = [];
        this.getList(this.dataInfo);
        this.finished = false;
      }, 500);
    },
    onLoad() {
      setTimeout(() => {
        // 异步更新数据
        this.dataInfo.page = this.dataInfo.page + 1;
        this.getList(this.dataInfo);
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
.all-comment-box {
  height: 100%;
  /*控制底部滚动*/
  overflow-y: scroll;
  box-sizing: border-box;
  .item-box {
    width: 100%;
    padding-bottom: 1rem;

    .list {
      width: 90%;
      margin: 0 auto;
      .comment-item {
        height: auto;
        width: 100%;
        margin: 0 auto;
        padding: 1rem 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        border-bottom: 1px solid #eee;
        .comment-item-top {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          width: 100%;
          .comment-item-name {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            img {
              width: 3.2rem;
              height: 3.2rem;
              border-radius: 100%;
              margin-right: 1rem;
            }
            .item-name {
              font-family: PingFangSC-Semibold;
              font-size: 1.4rem;
              color: #424242;
              line-height: 1.4rem;
            }
            .comment-item-tiem {
              opacity: 0.5;
              font-family: PingFangSC-Regular;
              font-size: 1.2rem;
              color: #424242;
              text-align: right;
              line-height: 1.2rem;
            }
          }
        }
        .comment-item-content {
          width: 100%;
          text-align: left;
          margin-top: 1rem;
          font-family: PingFangSC-Regular;
          font-size: 1.6rem;
          color: #424242;
          line-height: 2rem;
        }
        .comment-img {
          width: 100%;
          height: auto;
          text-align: left;
          margin-top: 1rem;
          .comment-img-box {
            height: 8rem;
            // width: 8rem;
            overflow: hidden;
            display: inline-block;
            img {
              width: 8rem;
              height: auto;
            }
          }
        }
      }
    }
  }
}
/deep/ .van-grid-item__content--center {
  padding: 0;
  height: 8rem;
  overflow: hidden;
}
/deep/ .van-icon__image {
  height: 100%;
  width: 100%;
}
.no-data {
  opacity: 0.5;
  font-family: PingFangSC-Regular;
  font-size: 1.4rem;
  color: #424242;
  letter-spacing: 0;
  line-height: 1.6rem;
}
</style>



// WEBPACK FOOTER //
// src/view/type/allComment.vue